export default __webpack_public_path__ + "static/studio-slider-4-b2d90cfc51a61b09d76e05364b474513.png";